<template>
	<div id="has-many-form-wrapper">
		<label>{{ prop_label }}</label>
		<p v-if="prop_sub_label">{{ prop_sub_label }}</p>

		<div class="group card transparent" v-for="(group, groupKey) in groups" :key="+ new Date()">
			<a class="remove-group" @click.prevent="deleteGroup(groupKey)"><i class="fa fa-times"></i></a>
			<input v-if="group.id" type="hidden" :name="generateInputName(groupKey, 'id')" :value="group.id">

			<has-many-form-inputs
				:prop_parent_field_key="prop_field_key"
				:prop_group_data="group"
				:prop_group_key="groupKey"
				:prop_fields="fields"
				v-on:togglePrimary="togglePrimary"
			></has-many-form-inputs>
		</div>

		<a class="add-group" @click.prevent="addNewGroup()" >Add {{ prop_label }}</a>
	</div>
</template>

<script>
	import hasManyFormInputs from "./HasManyFormInputs.vue"

	export default {
		components: {hasManyFormInputs},
		name: 'hasManyFormWrapper',
		props: {
			prop_fields: { type: String, required: true },
			prop_groups: { type: String, default: [] },
			prop_field_key: {type: String, required: true},
			prop_label: {},
			prop_sub_label: {}
		},
		data() {
			return {
				fields: [],
				groups: []
			}
		},
		methods: {
			addNewGroup: function(event) {
				this.groups.push({});
			},
			generateInputName: function(key, field) {
				return this.prop_field_key + "[" + key + "][" + field + "]";
			},
			deleteGroup: function(key) {
				if(confirm("Are you sure you want to delete this item?")) {
					this.groups.splice(key, 1);
				}
			},
			togglePrimary: function(prop_group_key) {
				if(!this.groups[prop_group_key].is_primary) { // condition is opposite because event is emitted before data is updated
					for (var index in this.groups) {
						if(index != prop_group_key) {
							this.groups[index].is_primary = false;
						}
					}
				}
			}
		},
		mounted() {
			this.fields = JSON.parse(this.prop_fields);
			this.groups = JSON.parse(this.prop_groups);
		},
	}
</script>

<style lang="scss" scoped>
	#has-many-form-wrapper {
		.group {
			position: relative;

			.remove-group {
				position: absolute;
				left: 25px;
    			top: 7px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// assets/js/vue/elements/HasManyFormWrapper.vue